import { enStatus } from './course';

export interface IComment {
  createdAt: string;
  id: number;
  status: enCommentStatus;
  text: string;
  totalReplies?: number;
  replies?: IComment[];
  user: {
    avatar: string;
    id: number;
    name: string;
  };
}

export enum enCommentStatus {
  'waiting-aproval' = 0,
  'public' = 1,
  'private' = 2
}

export interface ICommentCourse {
  createdAt: string;
  id: number;
  lessonId: number;
  lessonTitle: string;
  moduleTitle: string;
  status: enStatus;
  text: string;
}
